import React from 'react';
import { CM2Dataset } from '@interfaces/central-monitoring';
import { ReviewRAGChangeChipValues } from '@pages-clean/central-monitoring/monitoring-toolkit/tabs/kri-overview/constants';
import { ReviewContent } from '@pages-clean/central-monitoring/monitoring-toolkit/tabs/kri-overview/review-content';
import SankeyContent from '@pages-clean/central-monitoring/monitoring-toolkit/tabs/kri-overview/sankey-content';

interface IReviewRagSectionProps {
    studyRef: string;
    canEdit: boolean;
    panelReference?: string;
    datasetData?: CM2Dataset;
    comparisonData?: CM2Dataset;
    dataviewRef?: string | null;
    allowKRIReviewsState: boolean;
    selectedChip: ReviewRAGChangeChipValues;
    panelTitle?: string;
    includePurpleSites?: boolean;
}

const ReviewRagSectionContents = ({
    studyRef,
    canEdit,
    panelReference,
    selectedChip,
    datasetData,
    comparisonData,
    dataviewRef,
    allowKRIReviewsState,
    panelTitle,
    includePurpleSites,
}: IReviewRagSectionProps) => {
    if (selectedChip === ReviewRAGChangeChipValues.RAGChanges) {
        return (
            <SankeyContent
                studyRef={studyRef}
                panelReference={panelReference}
                datasetId={datasetData?.id}
                comparisonDatasetId={comparisonData?.id}
                popoutInfo={{
                    dataviewRef,
                    dataCutDate: datasetData?.dataCutDate,
                    comparisonDataCutDate: comparisonData?.dataCutDate,
                }}
                panelTitle={panelTitle}
                includePurpleSites={includePurpleSites}
            />
        );
    }
    if (selectedChip === ReviewRAGChangeChipValues.Review && allowKRIReviewsState) {
        return (
            <ReviewContent
                studyRef={studyRef}
                canEdit={canEdit}
                selectedPanelId={panelReference}
                datasetData={datasetData}
                comparisonData={comparisonData}
            />
        );
    }
};

export const ReviewRagSection = ({
    studyRef,
    canEdit,
    panelReference,
    datasetData,
    comparisonData,
    dataviewRef,
    allowKRIReviewsState,
    selectedChip,
    panelTitle,
    includePurpleSites,
}: IReviewRagSectionProps) => {
    return (
        <ReviewRagSectionContents
            studyRef={studyRef}
            canEdit={canEdit}
            panelReference={panelReference}
            selectedChip={selectedChip}
            datasetData={datasetData}
            comparisonData={comparisonData}
            dataviewRef={dataviewRef}
            allowKRIReviewsState={allowKRIReviewsState}
            panelTitle={panelTitle}
            includePurpleSites={includePurpleSites}
        />
    );
};
